import updateMessageLikers from '../actions/updateMessageLikers';
import likeItemService from '../services/likeItemService';
import { ClientItemId } from 'owa-client-ids';
import { TableView } from 'owa-mail-list-store';
import { InstrumentationContext } from 'owa-mail-store';
import Message from 'owa-service/lib/contract/Message';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { orchestrator } from 'satcheljs';
import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import { userMailInteractionAction } from 'owa-mail-actions';

const likeItem = action(
    'likeItem',
    (
        itemId: ClientItemId,
        message: Message,
        tableView: TableView,
        isLocalUpdateOnly: boolean,
        instrumentationContext: InstrumentationContext
    ) =>
        addDatapointConfig(
            {
                name: 'LikeItem',
                actionSource: 'ReadingPane',
            },
            {
                itemId,
                message,
                tableView,
                isLocalUpdateOnly,
                instrumentationContext,
            }
        )
);

orchestrator(likeItem, actionMessage => {
    const { tableView, itemId, message, instrumentationContext } = actionMessage;
    const userEmailAddress = getUserConfiguration().SessionSettings.UserEmailAddress;
    const isUnlike = message.Likers
        ? message.Likers.some(email => email.EmailAddress === userEmailAddress)
        : false;
    updateMessageLikers(
        message,
        tableView,
        isUnlike,
        userEmailAddress,
        getUserConfiguration().SessionSettings.UserDisplayName
    );
    if (!actionMessage.isLocalUpdateOnly) {
        likeItemService(itemId, isUnlike, itemId.mailboxInfo.requestOptions);
    }

    if (!isUnlike) {
        userMailInteractionAction('Like', [instrumentationContext]);
    }
});

export default likeItem;
